export default __webpack_public_path__ + "static/media/menu.f33d23e0.svg";